import { Module } from "vuex";

/**
 * 项目案例-工地
 * @type {Module}
 */
export const performanceExperience = {
  namespaced: true,
  state: {
    currentData:{}
  },
  mutations: {
      SaveCurrentData(state,payload) {
        state.currentData = payload
      }
  },
  actions: {},
  getters: {},
};
